export const chargeTypes = [
  { id: 'recurring', label: 'Cobro recurrente', icon: 'mdi-autorenew', description: 'Mis clientes pagan una suscripción periódica' },
  { id: 'variable', label: 'Por servicio o proyecto', icon: 'mdi-receipt-text', description: 'Facturo cada vez que vendo y entrego algo' },
  { id: 'both', label: 'Una mezcla de ambos', icon: 'mdi-swap-horizontal', description: 'Tengo clientes recurrentes y otros por servicio' }
]

export const customerTypes = [
  { id: 'b2b', label: 'Empresa', icon: 'mdi-office-building' },
  { id: 'b2c', label: 'Persona', icon: 'mdi-account' }
]

export const activeClientsRanges = [
  { id: '1_50', label: '1 - 50', icon: 'mdi-account-multiple' },
  { id: '51_250', label: '51 - 250', icon: 'mdi-account-multiple' },
  { id: '251_500', label: '251 - 500', icon: 'mdi-account-group' },
  { id: '500+', label: 'Más de 500', icon: 'mdi-account-multiple-plus' }
]

export const pricingModels = [
  { id: 'flat', label: 'Todos pagan lo mismo', icon: 'mdi-currency-usd' },
  { id: 'tiers', label: 'Tengo varios planes', icon: 'mdi-format-list-numbered' },
  { id: 'usage', label: 'Cobro por uso o consumo', icon: 'mdi-chart-bar' },
  { id: 'negotiated', label: 'Negociado con cada cliente', icon: 'mdi-handshake' },
  { id: 'mixed', label: 'Combino varios modelos', icon: 'mdi-shuffle-variant' }
]

export const billingFrequencies = [
  { id: 'monthly', label: 'Mensual', icon: 'mdi-calendar-month' },
  { id: 'annual', label: 'Anual', icon: 'mdi-calendar' },
  { id: 'mixed', label: 'Ambas', icon: 'mdi-calendar-multiple' },
  { id: 'other', label: 'Otra frecuencia', icon: 'mdi-dots-horizontal' }
]

export const invoicingMethods = [
  { id: 'manual', label: 'Desde un software de facturación', icon: 'mdi-table' },
  { id: 'semi_auto', label: 'Desde un ERP o back-office', icon: 'mdi-cog' },
  { id: 'none', label: 'Aún no facturo', icon: 'mdi-close-circle' },
  { id: 'other', label: 'Otro', icon: 'mdi-dots-horizontal' }
]

export const paymentMethods = [
  { id: 'transfer', label: 'Transferencia bancaria', icon: 'mdi-bank-transfer' },
  { id: 'card', label: 'Tarjeta de crédito o débito', icon: 'mdi-credit-card-outline' },
  { id: 'both', label: 'Ambas', icon: 'mdi-swap-horizontal' }
]

export const paymentProcessors = [
  { id: 'mercadopago', label: 'MercadoPago', icon: 'mdi-credit-card' },
  { id: 'getnet', label: 'Getnet', icon: 'mdi-credit-card' },
  { id: 'webpay', label: 'Webpay (Transbank)', icon: 'mdi-credit-card' },
  { id: 'oneclick', label: 'OneClick (Transbank)', icon: 'mdi-credit-card' },
  { id: 'khipu', label: 'Khipu', icon: 'mdi-credit-card' },
  { id: 'paypal', label: 'PayPal', icon: 'mdi-credit-card' },
  { id: 'stripe', label: 'Stripe', icon: 'mdi-credit-card' },
  { id: 'none', label: 'Todavía no uso uno', icon: 'mdi-help-circle' }
]

export const roles = [
  { id: 'finance', icon: 'mdi-bank', label: 'Finanzas / Contabilidad' },
  { id: 'engineering', icon: 'mdi-code-greater-than', label: 'Ingeniería' },
  { id: 'founder_excecutive', icon: 'mdi-lightbulb-on', label: 'Fundador / Ejecutivo' },
  { id: 'growth', icon: 'mdi-chart-box', label: 'Growth' },
  { id: 'sales', icon: 'mdi-briefcase-plus', label: 'Ventas' },
  { id: 'ops', icon: 'mdi-cog', label: 'Operaciones' },
  { id: 'other', icon: 'mdi-help-box', label: 'Otro' }
]

export const channels = [
  { id: 'search', label: 'Buscador (Google, Bing, etc.)' },
  { id: 'referrer', label: 'Amigo o colega' },
  { id: 'blog', label: 'Blog de Piriod' },
  { id: 'linkedin', label: 'LinkedIn' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'facebook', label: 'Facebook' },
  { id: 'instagram', label: 'Instagram' },
  { id: 'podcast', label: 'Podcast' },
  { id: 'webinar', label: 'Webinar' },
  { id: 'review_site', label: 'Sitios de reseñas de software' },
  { id: 'other', label: 'Otros' }
]

export const onboardingPaths = {
  SUBSCRIPTION_CARD: 'subscription_card',
  SUBSCRIPTION_TRANSFER: 'subscription_transfer',
  INVOICING_ONLY: 'invoicing_only'
}

// eslint-disable-next-line camelcase
export function computePath ({ charge_type, payment_method }) {
  // eslint-disable-next-line camelcase
  if (charge_type === 'variable') {
    return onboardingPaths.INVOICING_ONLY
  }

  // eslint-disable-next-line camelcase
  if (payment_method === 'card' || payment_method === 'both') {
    return onboardingPaths.SUBSCRIPTION_CARD
  }

  return onboardingPaths.SUBSCRIPTION_TRANSFER
}
